import React from "react";
import { Helmet } from "react-helmet-async";

import Section1 from "../includes/Careers/Section1";
import Section2 from "../includes/Careers/Section2";
import Section3 from "../includes/Careers/Section3";

const Careers = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/careers",
    },
    headline: "Careers at ExD Digital — Build The Future With Us",
    description:
      "Explore open roles at ExD Digital and join a team building AI-driven products and digital solutions for businesses worldwide.",
    image: "https://www.exddigital.com/images/exd_digital.webp",
    author: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        url: "https://www.exddigital.com/images/exd_digital.webp",
      },
    },
    datePublished: "2026-06-08",
    dateModified: "2026-06-08",
  };

  return (
    <>
      <Helmet>
        <title>Careers</title>
        <meta
          name="description"
          content="Explore open roles at ExD Digital and join a team building AI-driven products and digital solutions for businesses worldwide."
        />
        <link rel="canonical" href="https://www.exddigital.com/careers" />

        <meta property="og:title" content="Careers | ExD Digital" />
        <meta
          property="og:description"
          content="Explore open roles at ExD Digital and join a team building AI-driven products and digital solutions for businesses worldwide."
        />
        <meta property="og:url" content="https://www.exddigital.com/careers" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Careers | ExD Digital" />
        <meta
          name="twitter:description"
          content="Explore open roles at ExD Digital and join a team building AI-driven products and digital solutions for businesses worldwide."
        />
        <meta
          name="twitter:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <main className="careers-main">
        <article className="careers overflow-hidden">
          <Section1 url={devUrl} />
          <Section2 url={devUrl} />
          <Section3 url={devUrl} />
        </article>
      </main>
    </>
  );
};

export default React.memo(Careers);
